<template>
  <div class="auto-qa-table-section" v-loading="loading">
    <div class="wy-auto-qa-home-table">
      <!-- Panel Header  -->
      <div class="panel-header-wrapper">
        <div class="title-wrapper">
          <div class="title">Performance score chart</div>
          <div class="sub-title">Highlighting the best and worst day to day average scores</div>
        </div>
        <div class="dropdown-wrapper">
          <div class="pre-text">View by</div>
          <el-select ref="viewByDropdown" :disabled="!hasTableData" v-model="viewByPerformersType" popper-class="wy-auto-qa-home-page-table-performers-dropdown" :placeholder="viewByPerformersOptions[0].label">
            <el-option v-for="(item, index) in viewByPerformersOptions" :key="index" :label="item.label" :value="item.value" :selected="item.key === viewByPerformersOptions[0].value"> </el-option>
          </el-select>
        </div>
      </div>

      <!-- Table -->
      <div v-if="hasTableData" ref="wyTableList">
        <div class="wy-table-wrapper">
          <table v-if="this.tableData && this.tableData.groups.length > 0" border="0" class="wy-auto-qa-home-table-main">
            <thead>
              <tr ref="wyHeaderMain" class="wy-auto-qa-home-table-header">
                <th>Groups</th>
                <th>Average</th>
                <th>Best</th>
                <th>Worst</th>
              </tr>
            </thead>
            <tbody ref="wyTableBodyMain" class="wy-auto-qa-home-table-body">
              <tr v-for="(group, index) in tableData.groups" :key="index" class="group-row">
                <td class="underline" @click="handleGroupClick(group)">{{ group.name }}</td>
                <td>
                  <div v-bind:class="{'na-data': group.avgScore === -1}">
                    {{ renderNumber(group.avgScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': group.bestScore === -1}">
                    {{ renderNumber(group.bestScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': group.worstScore === -1}">
                    {{ renderNumber(group.worstScore) }}
                  </div>
                </td>
              </tr>
              <tr class="view-all">
                <td colspan="4" class="underline" @click="handleGroupClick({id:'all'})" data-testid="AutoQM-Home-PerformanceScoreChart-GroupsNames">View all</td>
              </tr>
            </tbody>
          </table>

          <table v-if="this.tableData && this.tableData.teams.length > 0" border="0" class="wy-auto-qa-home-table-main">
            <thead>
              <tr ref="wyHeaderMain" class="wy-auto-qa-home-table-header">
                <th>Teams</th>
                <th>Average</th>
                <th>Best</th>
                <th>Worst</th>
              </tr>
            </thead>
            <tbody ref="wyTableBodyMain" class="wy-auto-qa-home-table-body">
              <tr v-for="(team, index) in tableData.teams" :key="index + 100" class="team-row">
                <td class="underline" @click="handleTeamClick(team)">{{ team.name }}</td>
                <td>
                  <div v-bind:class="{'na-data': team.avgScore === -1}">
                    {{ renderNumber(team.avgScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': team.bestScore === -1}">
                    {{ renderNumber(team.bestScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': team.worstScore === -1}">
                    {{ renderNumber(team.worstScore) }}
                  </div>
                </td>
              </tr>
              <tr class="view-all">
                <td colspan="4" class="underline" @click="handleTeamClick({id:'all'})" data-testid="AutoQM-Home-PerformanceScoreChart-TeamsNames">View all</td>
              </tr>
            </tbody>
          </table>

          <table v-if="this.tableData && this.tableData.agents.length > 0" border="0" class="wy-auto-qa-home-table-main">
            <thead>
              <tr ref="wyHeaderMain" class="wy-auto-qa-home-table-header">
                <th>Agents</th>
                <th>Average</th>
                <th>Best</th>
                <th>Worst</th>
              </tr>
            </thead>
            <tbody ref="wyTableBodyMain" class="wy-auto-qa-home-table-body">
              <tr v-for="(agent, index) in tableData.agents" :key="index + 200" class="agent-row">
                <td class="underline" @click="handleAgentClick(agent)">{{ agent.name }}</td>
                <td>
                  <div v-bind:class="{'na-data': agent.avgScore === -1}">
                    {{ renderNumber(agent.avgScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': agent.bestScore === -1}">
                    {{ renderNumber(agent.bestScore) }}
                  </div>
                </td>
                <td>
                  <div v-bind:class="{'na-data': agent.worstScore === -1}">
                    {{ renderNumber(agent.worstScore) }}
                  </div>
                </td>
              </tr>
              <!-- <tr class="view-all">
                <td colspan="4" @click="handleAgentClick({id:'all'})">View all</td>
              </tr> -->
            </tbody>
          </table>
        </div>
      </div>

      <div v-else class="no-data">
        <div class="message">{{$t('noDataFound.message')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "wy-auto-qa-home",
  props: ['loading', 'controller', 'tableData'],
  data() {
    return {
      viewByPerformersOptions: [{ value: "bestScore", label: "Highest performers" }, { value: "worstScore", label: "Lowest performers" }],
      viewByPerformersType: "bestScore",
    };
  },
  watch: {
    viewByPerformersType: async function () {
      await this.controller.fetchPerformanceScores();
    },
  },
  computed: {
    hasTableData() {
      return this.tableData && (this.tableData.groups.length > 0 || this.tableData.teams.length > 0 || this.tableData.agents.length > 0);
    },
  },
  methods: {
    renderNumber(value) {
      if (value == null) return '0.00'
      if (value == -1) return 'N/A'
      return Number(value).toFixed(2);
    },

    handleGroupClick(item) {
      this.$router.push({ name: 'autoQAEvaluationGroupsTeams', params: { groupId: item.id}});
    },

    handleTeamClick(item) {
      this.$router.push({ name: 'autoQAEvaluationGroupsTeams', params: { teamId: item.id}});
    },

    handleAgentClick(item) {
      this.$router.push({ name: 'autoQAEvaluationAgent', params: { agent: {id: item.id, displayName: item.name}}});
    },
  },
});
</script>

<style lang="scss">
$table-spacing: 20px;

.auto-qa-table-section {
  margin-bottom: 50px;
  margin: 10px 0px 20px 0px;
  width: unset;
  min-height: 512px;

  border: 1px solid #e0e0e0;
  border-radius: 6px;

  .wy-auto-qa-home-table {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    padding: 30px 24px;
    background-color: #fff;
    border-radius: 6px;

    .panel-header-wrapper {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;

      .title-wrapper {
        color: black;
        padding-left: 10px;

        .title {
          font-size: 22px;
          font-weight: bold;
          margin-bottom: 8px;
        }
        .sub-title {
          font-size: 16px;
        }
      }

      .dropdown-wrapper {
        .pre-text {
          font-size: 12px;
          margin-bottom: 2px;
          color: #64727c;
        }
        input.el-input__inner {
          border-width: 1px !important;
          border-radius: 4px !important;
          padding-left: 10px !important;
        }

        .el-select .el-input__inner {
          padding-right: 10px !important;
        }

        .el-select .el-input .el-select__caret {
          color: black;
        }
      }
    }

    .el-select .el-input.is-focus .el-input__inner {
      border-color: #dcdfe6 !important;
    }

    .wy-table-wrapper {
      overflow-x: hidden;
    }

    .wy-auto-qa-home-table-main {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
    }

    // no margin-bottom for last table
    .wy-auto-qa-home-table-main:last-child {
      margin-bottom: 0;
    }

    .wy-auto-qa-home-table-header th {
      text-align: left;
      padding: 16px 12px 20px 12px;
      font-weight: 600;
      color: #64727c;
      border-bottom: 1px solid #e0e0e0;
    }

    .wy-auto-qa-home-table-body tr {
      background-color: #fafbfb;
      .underline {
        color: #006fe7;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .wy-auto-qa-home-table-body td {
      padding: 12px;
      color: #333;
      text-align: left;
    }

    // first column
    .wy-auto-qa-home-table-body td:first-child {
      width: 500px;
    }

    .group-row td,
    .team-row td,
    .agent-row td {
      padding: 16px 12px;
      color: #333;
      font-weight: 500;
      width: 300px;
    }

    // for third td make width 200px
    .group-row td:nth-child(2),
    .team-row td:nth-child(2),
    .agent-row td:nth-child(2) {
      width: 200px;
    }

    .view-all {
      text-align: center;
    }

    .view-all a {
      color: #006fe7;
      font-weight: 500;
      text-decoration: underline;
    }

    .view-all td {
      padding: 12px;
      background-color: white;
    }
    .na-data {
      border-radius: 30px;
      background-color: #e4e8ec;
      width: 50px;
      padding: 5px 0;
      margin-right: 0;
      text-align: center;
    }
  }
  
  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding-top: 80px;

    .message {
      max-width: 400px;
      font-weight: 500;
      line-height: 22px;
      font-size: 14px;
      text-align: center;
      text-align: center;
      color: #4b5158 !important;
    }
  }
}

.wy-auto-qa-home-page-table-performers-dropdown {
  .el-select-dropdown__item {
    font-size: 14px;
    padding: 0 20px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #606266;
    height: 34px;
    line-height: 34px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
  .el-select-dropdown__item.hover {
    background-color: #f5f7fa;
  }
  .el-select-dropdown__item.selected {
    color: #1a55ad !important;
    background-color: #e8f1ff !important;
    font-weight: 500 !important;
  }
}
</style>
